import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Lock } from 'lucide-react';
export function OfferSection() {
  return <section className="py-32 relative overflow-hidden" data-id="element-89">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-emerald-500/10 blur-[150px] rounded-full pointer-events-none" data-id="element-90" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-gradient-to-b from-[#162019] to-[#0f1a14] border border-emerald-500/30 rounded-3xl p-8 md:p-16 text-center shadow-[0_0_50px_rgba(16,185,129,0.1)]" data-id="element-92">
          <h2 id="offer" className="text-3xl md:text-5xl font-bold text-white mb-6 scroll-mt-12" data-id="element-93">
            Recupera el mando de tu vitalidad hoy mismo.
          </h2>

          <p className="text-lg md:text-xl text-gray-300 mb-12 max-w-2xl mx-auto" data-id="element-94">
            El manual completo "Metabolismo en Punto de Equilibrio (40+)" está
            disponible por una fracción de lo que cuesta una consulta
            especializada o meses de suplementos innecesarios.
          </p>

          <div className="mb-10" data-id="element-95">
            <p className="text-emerald-400 font-medium uppercase tracking-wider mb-2" data-id="element-96">
              Inversión única
            </p>
            <div className="text-6xl md:text-7xl font-extrabold text-white tracking-tight" data-id="element-97">
              $6.39{' '}
              <span className="text-3xl text-gray-400 font-medium" data-id="element-98">USD</span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-99">
            <CTAButton href="https://pay.hotmart.com/A104892992N" className="w-full sm:w-auto" data-id="element-100" />

            <div className="flex items-center gap-2 text-sm text-gray-400 mt-4" data-id="element-101">
              <Lock className="w-4 h-4" data-id="element-102" />
              <span data-id="element-103">Acceso inmediato tras la compra. Pago 100% seguro.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}